
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 15c-1.1 0-1.3 1.7-2 2-2.2.9-6.9-6.2-6-8 .4-.8 2-.7 2-2 0-1.1-1.7-4.5-3-4S4 4.8 4 8c0 2.1.4 4.5 3 8s5.9 5 8 5c2.1.1 4.1-1.1 5-3 .5-1.4-3-3-4-3z"}})])
          )
        }
      }
    